import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/layout/Header";
import { OrganizationCard } from "../../components/organizations/OrganizationCard";
import { LoadingSkeleton } from "../../components/common/LoadingSkeleton";
import { useAuth } from "../../hooks/useAuth";
import styles from "./OrganizationListPage.module.css";

export default function OrganizationListPage() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const organizations = user?.organizations ?? [];

  if (loading) {
    return (
      <>
        <Header />
        <div className="container">
          <div className={styles.pageHeader}>
            <h1>{t("organizations.title")}</h1>
          </div>
          <LoadingSkeleton type="card" count={3} />
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className={styles.pageHeader}>
          <h1>{t("organizations.title")}</h1>
          <Link to="/organizations/create" className="button button-primary">
            {t("organizations.createButton")}
          </Link>
        </div>

        {organizations.length === 0 ? (
          <div className={styles.emptyState}>
            <p>{t("organizations.noOrganizations")}</p>
            <Link to="/organizations/create" className="button button-primary">
              {t("organizations.createFirstButton")}
            </Link>
          </div>
        ) : (
          <div className={styles.organizationGrid}>
            {organizations.map((org) => (
              <OrganizationCard key={org.id} organization={org} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}
